// extracted by mini-css-extract-plugin
module.exports = {"sectionTop":"SectionTop_sectionTop_vjvVQ"};